import { render, staticRenderFns } from "./entrada-balanca.vue?vue&type=template&id=2037d5d8&"
import script from "./entrada-balanca.vue?vue&type=script&lang=js&"
export * from "./entrada-balanca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports